import React, { Component } from 'react';
import './style.scss';
//import Slider from "react-slick";
import { Link } from 'react-router-dom';
//import LinkTo from '../../../../components/LinkTo/LinkTo';
import { data } from './translations.js';
import { tl } from '../../../../shared/helpers';

class CategoryMenu extends Component {

     
    formatOption = (o, nobrackets = false) => {
		if (!nobrackets) {
			// Only show what's in the brackets.
			var regex = /.*\((.*)\)/g;
			var matches = regex.exec(o);
			if (matches)
				return matches[1];
		}
		return (o ?? "").replace("(", "").replace(")", "").trim();
    }
    
    render() {
        //console.log('cat menu props ',this.props);
        // var hc = this.handleChange;
        // var cat = this.state.cat;
        // var ac = this.hashClick;
        // var fo = this.formatOption;
        // var ft = this.formatTrim;

        //     var anchors = this.props.list.map(function(i) {
        //         return <a key={i} name={i} />;
        //     });

        //     var men = this.props.navItems.map(function(i, index, data) { 
        // 		var className = (ft(i) == cat) ? 'current' : '';
        //   var dataCatName = i.replace("(", "").replace(")", "").trim();
        
        // 		return <div key={i} data-category={dataCatName} className={"cat " + helpers.slug(i) + (index == data.length -1 ? ' last' : '')} onClick={hc}><a title={fo(i)} data-cat={"#" + fo(i)} onClick={ac} className={className} href={fo(i)}>{fo(lang.t(i))}</a></div>;
        // });

        // format option href

        const menuOrder = ["featured", "burgers", "chicken", "breakfast", "sides", "kidspack", "drinks", "brewbar", "pret"];

		// Construct the list in a slightly less alarming way
		let category = this.formatOption(this.props.category);
		let menuLinks = [];
		const navItems = this.props.navItems.map((a)=>a.toLowerCase());
		for (let i = 0; i < menuOrder.length; i++) {
			const v = menuOrder[i];
			const name = this.formatOption(v);
			if (navItems.includes(name)) {
				let className = v === category ? 'active' : name;
				if(this.props.ourMenuPage){
					menuLinks.push(<Link key={name} to={`/${this.props.lang}/our-menu/${v}`} className={className} > { tl(data, name, this.props.lang) }</Link>)
				}else {
					menuLinks.push(<Link key={name} onClick={(e) => this.props.onCategoryChange(e, v)} to={`/${this.props.lang}/our-menu/${v}`} className={className} > { tl(data, name, this.props.lang) }</Link>)
				}
			}
		}
		// We can throw any extra ones at the end, but we probably don't want to since the routing won't account for them anyway
        return (
            <div className="category-menu-wrapper">

                <div className="category-menu">
                    {menuLinks}
                </div>
                    
            </div>
        );
    }
}

export default CategoryMenu;